import { Fragment, useState } from "react";
import GoogleAd from "./GoogleAd";

const DOUBLE_SLOT = "8549446262";
const SQUARE_SLOT_1 = "4212484119";
const SQUARE_SLOT_2 = "2899402443";

const Kosana = (props: any) => {
  const [failCount, setFailCount] = useState(0);

  const handleAdFailed = () => {
    setFailCount((prev) => prev + 1);
  };

  if (props.ads == "double" && failCount >= 1) return null;
  if (props.ads == "square" && failCount >= 2) return null;

  return (
    <Fragment>
      {props.ads == "double" ? (
        <div className="w-[100%] max-w-[300px] md:w-full relative m-auto">
          <GoogleAd
            client="ca-pub-6015892276154863"
            slot={DOUBLE_SLOT}
            style={{ display: "block" }}
            format="auto"
            responsive="true"
            onAdFailed={handleAdFailed}
          />
        </div>
      ) : props.ads == "square" ? (
        <div className="w-full flex flex-row md:flex-col items-center gap-2 relative">
          <div className="w-full max-w-[300px]">
            <GoogleAd
              client="ca-pub-6015892276154863"
              slot={SQUARE_SLOT_1}
              style={{ display: "block" }}
              format="auto"
              responsive="true"
              onAdFailed={handleAdFailed}
            />
          </div>
          <div className="w-full max-w-[300px]">
            <GoogleAd
              client="ca-pub-6015892276154863"
              slot={SQUARE_SLOT_2}
              style={{ display: "block" }}
              format="auto"
              responsive="true"
              onAdFailed={handleAdFailed}
            />
          </div>
        </div>
      ) : (
        ""
      )}
    </Fragment>
  );
};

export default Kosana;
